import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "After a year, my first business diary retires",
  "description": "",
  "published": "2016-08-26T00:00:00.000Z",
  "redirect_from": ["/blog/after-a-year-my-first-business-diary-retires/swizec/6978"],
  "categories": "Business, Learning, Personal, side business, Side Projects",
  "hero": "./img/i6gmKrF.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This week last year, I started a business diary. Spurred on by the success of `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React+d3js`}</a>{`, it was time to get serious.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "720px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.88789237668162%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2022c0%2012%200%2022%201%2021s6-3%208-2c2%200%200%202-2%202-4%200-4%203-1%205l20%201%2012%201-19%201H0v21h4l17-2c15%200%2019-2%2033-13%209-7%2012-9%208-8l-3-1%203-1c3%200%208-2%208-3s3-2%2019-3l44-5c34-5%2061%201%2075%2016%203%203%203%203%205%202l5-4c7-3%2029-1%2066%206l27%203c45%202%2059%204%2061%209l2%203%206%2021a725%20725%200%200016%2045l3-2a243%20243%200%20001-44c0%202-3-1-3-3%200-3-2-5-6-6-2%200-3-1-3-3%200-1-1-3-4-4l-4-4-3-3-2-1-4-5-5-7-3-3-6-6c0-2%2011-1%2012%201l9%202%2014%202%208%202v9l1-26c0-20-1-28-1-17v20l-13%201-17%202h-17c-13-1-13-2-14-4%200-2-1-3-4-4s-2-3%201-8l5-9c4-6%205-7%209-4%203%203%2010%205%2013%203%201-1%201-1-2-1-4%200-10-2-11-5l4-5%204-4c0-2-3-1-5%202-3%203-6%203-4%200s2-3%200-3l-2%201h-10l-1%202v5l-2%203-4%203c-2%200-2%201%201-7l2-7h-3c-4%200-4%200-4%204-2%209-6%2011-11%206-2-2-2-2%200-4l6-4%204-1-162-1H0v22M369%202l-1%204-2%206c-2%203-2%203%200%203l3%202c1%202%203%203%205%203l9%201c-4-1-5-2-2-4l-4%201-3-3c-1-5-1-7%201-10s3-5%201-3h-3c0-2-4-2-4%200m-72%2030l-7%201c-10%200-14%200-15%202l-1%201%205%201c12%202%2024%200%2025-4%200-2-1-2-3-2l-4%201M13%2085C4%2087%201%2090%201%2096v5l7-6a342%20342%200%200012-10h-7m143%2056l-6%2013h-1l-1%202v1l-13%2018a4644%204644%200%2001-45%2072c-11%2017-9%2016-12%2014a252%20252%200%2000-77-30l-1%2035v34h13l21-2a2463%202463%200%2000114%201l105%201-11-3a3741%203741%200%2001-110-33%20182%20182%200%2000-40-7c1%200%202-1%202-3l6-9%204-8%202-3v-2l1-1%203-3c1-3%202-4%204-4%202-1%202-1%201-2s1-5%204-8l1-3%201-1c2%200%204-2%202-2l1-5c2-3%204-5%208-6%201-1%200-1-1-1-2%200-3-1-3-2%200-2%201-2%202-2h1c-1%200-1-1%201-3%201-2%201-2%202%200%201%201%201%201%201-1-1-1%200-2%201-2v-2c-1-1-1-1%201-2l2-4%202-3%201-2c0-3%200-3%201-2h1l1-3%201-1%201-2%201-1%202-4c1-1%201-1%201%201v2h1l5-1%206-1c3-3%202-5%200-2-2%202-6%202-6%200h-5c-1-1-1-1%201-3%202-1%202-1%201-2l-1-2%202%201c1%202%207%200%207-3%200-2-1-2-3-2h-2l1-1%201-1-1-1c-2%201-2%200-1-2%202-2%202-2%202%200%201%202%201%202%201%200l1-3%202-3%201-5c1-4%200-2-8%209m12%2098l-1%201v3l-4%203c-6%200-25%208-22%209l3-1c2-2%2014-6%2017-6%202%200%201%201-3%206-3%203-5%206-5%208l1%202c3-2%2031%205%2056%2014a620%20620%200%200052%2015c1%201%202%200%202-2%201-5%2015-18%2019-18%201%200%202%200%201-1a1207%201207%200%2000-107-31l-9-2m0%203v4l-2%202-11%2012c0%201%205%203%2012%204%2015%203%2024%206%2046%2013l32%2010c18%204%2017%204%2017%202l7-8%208-8c1-2%200-2-11-6a1526%201526%200%2000-98-25m47%2022c-3%202-2%203%202%202%204%200%204%200%205%203s5%205%208%203c1-2%204%200%204%201v3l1-1c0-2%201-2%204-1%201%201%202%202%201%203l1%201%202-4-4-2-4-3c0-2%204-3%204-1l2%201c1-1-3-4-5-4l-3%203c0%203-1%203-4%200l-2-2c-1%201-3%200-4-1-4-2-6-2-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/72c693c4506771efa6c50982136fba8a/ca0a1/i6gmKrF.webp 223w", "/static/72c693c4506771efa6c50982136fba8a/75680/i6gmKrF.webp 445w", "/static/72c693c4506771efa6c50982136fba8a/bc514/i6gmKrF.webp 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/72c693c4506771efa6c50982136fba8a/853b2/i6gmKrF.jpg 223w", "/static/72c693c4506771efa6c50982136fba8a/0a4fe/i6gmKrF.jpg 445w", "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg",
              "alt": "i6gmKrF",
              "title": "i6gmKrF",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Every week, I would write down some numbers, take stock of how I pushed my side-hustle forward, and brainstorm some ideas on what to do next. Here’s what that first page said:`}</p>
    <p><strong parentName="p">{`Sales this week`}</strong>{` - `}<em parentName="p">{`Aug 9th, 2015 - Aug 15th, 2015`}</em>{`:`}</p>
    <p>{`10 Student packages -> $87`}</p>
    <p>{`1 Engineer package -> $59`}</p>
    <p><strong parentName="p">{`Audience`}</strong>{`:`}</p>
    <p>{`Udemy course -> 112 students`}<a parentName="p" {...{
        "href": "#fn1-1729",
        "title": "see footnote"
      }}>{`1`}</a></p>
    <p>{`Reactd3 email subscribers -> 160`}</p>
    <p>{`Blog subscribers -> 78`}</p>
    <p><strong parentName="p">{`Marketing`}</strong></p>
    <p>{`React page views: 380`}</p>
    <p>{`Adwords: $70, 11k views, 30 clicks`}</p>
    <p>{`FB ads: $1, 5 actions, 4 clicks`}</p>
    <p><strong parentName="p">{`Things`}</strong></p>
    <ul>
      <li parentName="ul">{`published promo blogpost, `}<a parentName="li" {...{
          "href": "https://swizec.com/blog/using-react-in-the-real-world/swizec/6710"
        }}>{`this one`}</a></li>
      <li parentName="ul">{`adjusted Drip campaign timing`}</li>
      <li parentName="ul">{`researched email performance`}</li>
      <li parentName="ul">{`started working on React+d3js update`}</li>
    </ul>
    <p><strong parentName="p">{`Result`}</strong></p>
    <p>{`$75 profit`}</p>
    <hr></hr>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "720px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.88789237668162%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2022c0%2012%200%2022%201%2021s6-3%208-2c2%200%200%202-2%202-4%200-4%203-1%205l20%201%2012%201-19%201H0v21h4l17-2c15%200%2019-2%2033-13%209-7%2012-9%208-8l-3-1%203-1c3%200%208-2%208-3s3-2%2019-3l44-5c34-5%2061%201%2075%2016%203%203%203%203%205%202l5-4c7-3%2029-1%2066%206l27%203c45%202%2059%204%2061%209l2%203%206%2021a725%20725%200%200016%2045l3-2a243%20243%200%20001-44c0%202-3-1-3-3%200-3-2-5-6-6-2%200-3-1-3-3%200-1-1-3-4-4l-4-4-3-3-2-1-4-5-5-7-3-3-6-6c0-2%2011-1%2012%201l9%202%2014%202%208%202v9l1-26c0-20-1-28-1-17v20l-13%201-17%202h-17c-13-1-13-2-14-4%200-2-1-3-4-4s-2-3%201-8l5-9c4-6%205-7%209-4%203%203%2010%205%2013%203%201-1%201-1-2-1-4%200-10-2-11-5l4-5%204-4c0-2-3-1-5%202-3%203-6%203-4%200s2-3%200-3l-2%201h-10l-1%202v5l-2%203-4%203c-2%200-2%201%201-7l2-7h-3c-4%200-4%200-4%204-2%209-6%2011-11%206-2-2-2-2%200-4l6-4%204-1-162-1H0v22M369%202l-1%204-2%206c-2%203-2%203%200%203l3%202c1%202%203%203%205%203l9%201c-4-1-5-2-2-4l-4%201-3-3c-1-5-1-7%201-10s3-5%201-3h-3c0-2-4-2-4%200m-72%2030l-7%201c-10%200-14%200-15%202l-1%201%205%201c12%202%2024%200%2025-4%200-2-1-2-3-2l-4%201M13%2085C4%2087%201%2090%201%2096v5l7-6a342%20342%200%200012-10h-7m143%2056l-6%2013h-1l-1%202v1l-13%2018a4644%204644%200%2001-45%2072c-11%2017-9%2016-12%2014a252%20252%200%2000-77-30l-1%2035v34h13l21-2a2463%202463%200%2000114%201l105%201-11-3a3741%203741%200%2001-110-33%20182%20182%200%2000-40-7c1%200%202-1%202-3l6-9%204-8%202-3v-2l1-1%203-3c1-3%202-4%204-4%202-1%202-1%201-2s1-5%204-8l1-3%201-1c2%200%204-2%202-2l1-5c2-3%204-5%208-6%201-1%200-1-1-1-2%200-3-1-3-2%200-2%201-2%202-2h1c-1%200-1-1%201-3%201-2%201-2%202%200%201%201%201%201%201-1-1-1%200-2%201-2v-2c-1-1-1-1%201-2l2-4%202-3%201-2c0-3%200-3%201-2h1l1-3%201-1%201-2%201-1%202-4c1-1%201-1%201%201v2h1l5-1%206-1c3-3%202-5%200-2-2%202-6%202-6%200h-5c-1-1-1-1%201-3%202-1%202-1%201-2l-1-2%202%201c1%202%207%200%207-3%200-2-1-2-3-2h-2l1-1%201-1-1-1c-2%201-2%200-1-2%202-2%202-2%202%200%201%202%201%202%201%200l1-3%202-3%201-5c1-4%200-2-8%209m12%2098l-1%201v3l-4%203c-6%200-25%208-22%209l3-1c2-2%2014-6%2017-6%202%200%201%201-3%206-3%203-5%206-5%208l1%202c3-2%2031%205%2056%2014a620%20620%200%200052%2015c1%201%202%200%202-2%201-5%2015-18%2019-18%201%200%202%200%201-1a1207%201207%200%2000-107-31l-9-2m0%203v4l-2%202-11%2012c0%201%205%203%2012%204%2015%203%2024%206%2046%2013l32%2010c18%204%2017%204%2017%202l7-8%208-8c1-2%200-2-11-6a1526%201526%200%2000-98-25m47%2022c-3%202-2%203%202%202%204%200%204%200%205%203s5%205%208%203c1-2%204%200%204%201v3l1-1c0-2%201-2%204-1%201%201%202%202%201%203l1%201%202-4-4-2-4-3c0-2%204-3%204-1l2%201c1-1-3-4-5-4l-3%203c0%203-1%203-4%200l-2-2c-1%201-3%200-4-1-4-2-6-2-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/72c693c4506771efa6c50982136fba8a/ca0a1/i6gmKrF.webp 223w", "/static/72c693c4506771efa6c50982136fba8a/75680/i6gmKrF.webp 445w", "/static/72c693c4506771efa6c50982136fba8a/bc514/i6gmKrF.webp 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/72c693c4506771efa6c50982136fba8a/853b2/i6gmKrF.jpg 223w", "/static/72c693c4506771efa6c50982136fba8a/0a4fe/i6gmKrF.jpg 445w", "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/72c693c4506771efa6c50982136fba8a/80e3c/i6gmKrF.jpg",
              "alt": "i6gmKrF",
              "title": "i6gmKrF",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`This Sunday, I wrote the last page that would fit in this notebook. Most entries were about a week apart, but some had an entire month between them. Life gets busy, and transcribing stats from charts you find online into a notebook is never a priority.`}</p>
    <p>{`Here’s what the last page says:`}</p>
    <p><strong parentName="p">{`Sales this week`}</strong></p>
    <p>{`7 student packages -> $117`}</p>
    <p>{`4 Why programmers work at night -> $0`}</p>
    <p>{`53 ES6 cheatsheet -> $8`}</p>
    <p><strong parentName="p">{`Subscribers`}</strong></p>
    <p>{`Reactd3 -> 4,341`}</p>
    <p>{`Why programmers work at night -> 736`}</p>
    <p>{`Blog -> 944`}</p>
    <p>{`Live coding -> 194`}</p>
    <p>{`Medium -> 427`}</p>
    <p><strong parentName="p">{`Marketing`}</strong></p>
    <p>{`FBads: $46, 29 leads, decent reach`}</p>
    <p><strong parentName="p">{`Result`}</strong></p>
    <p>{`$201 loss ?`}</p>
    <p><strong parentName="p">{`Things`}</strong></p>
    <ul>
      <li parentName="ul">{`paid my editor`}</li>
      <li parentName="ul">{`I should move this to a spreadsheet`}</li>
    </ul>
    <p>{`I probably `}<em parentName="p">{`should`}</em>{` move my diary into a spreadsheet, but I’m on the fence about this. A spreadsheet makes it easier to look at trends and draw pretty graphs. A notebook makes it easier to appreciate life.`}</p>
    <p>{`And yes, the last week in this diary is a $201 loss while the first week was a $75 profit. What a colossal failure! But not really. It fluctuates. Unlike a year ago, I have an editor now. I pay somebody to look at every single thing I publish.`}</p>
    <p>{`I started looking for one right after that first week in the diary. A few weeks later, I had an editor. My side-hustle usually has a loss on the weeks that his monthly invoice comes through.`}</p>
    <p>{`Such is life.`}</p>
    <hr></hr>
    <p>{`Here’s what happened in this year of side-hustling:`}</p>
    <p><strong parentName="p">{`React Indie Bundle`}</strong>{` - 6 authors, 1 sale, $30k in a week`}</p>
    <p><strong parentName="p">{`React+d3js ES6`}</strong>{` - book rewrite, relaunch, $9k in first month`}</p>
    <p><strong parentName="p">{`Weekly livecoding`}</strong>{` - pure fun, excuse to do cool shit`}</p>
    <p><strong parentName="p">{`React+D3 workshops`}</strong>{` - 3 iterations, about $9k`}</p>
    <p><strong parentName="p">{`ES6 cheatsheet`}</strong>{` - 1,184 emails, $314`}</p>
    <p><strong parentName="p">{`Daily blogging experiment`}</strong>{` - ongoing, stay tuned`}</p>
    <p>{`$27k in my share of sales`}<a parentName="p" {...{
        "href": "#fn2-1729",
        "title": "see footnote"
      }}>{`2`}</a>{`; 4 products launched; 2 things started to encourage doing cool shit; $4k spent on advertising; $2k on consultants; and some $2k on education materials.`}</p>
    <p>{`That’s an overall profit of about $19k.`}</p>
    <p>{`Which means I’m not investing enough in growth.`}</p>
    <hr></hr>
    <ol>
      <li parentName="ol"></li>
      <li parentName="ol">
        <p parentName="li">{`This was my Mastering d3.js video course published through Packt. It has since died a whimpering death and has gone from Udemy. I don’t know if it’s still making sales somewhere else. We never even broke through the advance amount. `}<a parentName="p" {...{
            "href": "#fnr1-1729",
            "title": "return to article"
          }}>{`↩︎`}</a></p>
      </li>
      <li parentName="ol"></li>
    </ol>
    <p>{`4)  React Indie Bundle and the Workshops are a collaboration so I don’t get the whole pie. `}<a parentName="p" {...{
        "href": "#fnr2-1729",
        "title": "return to article"
      }}>{`↩︎`}</a></p>
    <p>{`5)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      